<template>
    <div>
        <v-dialog :value="value" :width="850" @input="handlePopup">
            <v-card class="pa-6 text-left" min-height="">
                <v-row>
                    <v-col class="">
                        <h4 class="q-display-1 pa-5 white--text text-center q_leads_1">Impersonation is not available
                        </h4>
                    </v-col>
                </v-row>
                <p>This agent is unable to be impersonated because their tenant is disabled.</p>
                <v-row justify="center">
                    <v-btn @click="handlePopup(false)">Cancel</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    name: 'QUnableImpersonating',
    props: {
        value: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        handlePopup(e) {
            this.$emit('input', e)
        },
    },
}
</script>
